export const translations = {
  no: {
    nav: {
      home: "Hjem",
      huseier: "Huseiere",
      pendler: "Pendlere",
      om: "Om oss",
      kontakt: "Kontakt",
      cta: "Bli varslet",
      langToggle: "EN",
    },
    common: {
      submit: "Varsle meg når Pendli lanserer",
      submitting: "Sender...",
      successTitle: "Du er på listen.",
      successBody: "Vi sender deg en e-post så snart Pendli lanserer i ditt område.",
      privacy: "Vi deler ikke informasjonen din med noen. Du kan melde deg av når som helst.",
      consentLabel: "Jeg har lest og godtar",
      consentLinkText: "personvernerklæringen",
      consentRequired: "Du må godta personvernerklæringen for å fortsette.",
      namePlaceholder: "Ditt navn",
      contactPlaceholder: "E-post eller telefon",
      messagePlaceholder: "Melding (valgfritt)",
      stationPlaceholder: "Stasjon du pendler fra",
      addressPlaceholder: "Adresse (gate, område)",
      errorGeneric: "Noe gikk galt. Prøv igjen.",
      forCommuters: "For pendlere",
      forHomeowners: "For huseiere",
      learnMore: "Les mer",
    },
    home: {
      heroEyebrow: "Lanseres snart — Asker stasjon",
      heroTitle: "Garantert parkering nær din stasjon.",
      heroTitleAccent: "Plassen din venter på deg.",
      heroSub: "Forhåndsbook en privat plass hos en nabo nær stasjonen du pendler fra. Den står klar når du kommer. Du trenger ikke å sirkle, ingen usikkerhet, og ingen anlegg som er fullt klokka 07:30.",
      ctaPendler: "Jeg pendler",
      ctaHuseier: "Jeg har oppkjørsel",
      problemEyebrow: "Problemet",
      problemTitle: "Hver morgen er det det samme.",
      problemBody: "Du kjører til stasjonen. Anlegget er fullt. Du sirkler. Du betaler over 100 kr for å stå der hele dagen — eller får bot. Samtidig står tusenvis av oppkjørsler tomme bare noen meter unna.",
      howEyebrow: "Slik fungerer Pendli",
      howTitle: "Tre steg. Ingen sirkling.",
      step1Title: "Finn din plass",
      step1Body: "Etter du har lastet ned app'en, søker du på din stasjon. Se private plasser med kort gangavstand til stasjonen.",
      step2Title: "Forhåndsbook",
      step2Body: "Velg dag eller tegn månedsabonnement. Plassen er garantert ledig.",
      step3Title: "Parker. Gå til toget. Ferdig.",
      step3Body: "Park og gå til toget. Pendli håndterer hele betalingen og utbetaler inntektene til naboen.",
      audienceTitle: "To sider av samme oppkjørsel.",
      audiencePendlerTitle: "Du pendler",
      audiencePendlerBody: "Slutt å sirkle. Plassen din er låst inn før du forlater huset — og står og venter når du kommer.",
      audienceHuseierTitle: "Du har en ledig oppkjørsel",
      audienceHuseierBody: "Den står tom mens du er på jobb. Tjen 1 000–2 500 kr/mnd. Du setter prisen.",
      trustTitle: "Bygget for nordiske naboer.",
      trust1: "Pendli håndterer hele betalingen",
      trust1Body: "Pendlere betaler når de forhåndsbestiller. Pendli utbetaler inntektene til huseieren.",
      trust2: "Verifiserte brukere",
      trust2Body: "Du ser hvem som forhåndsbestiller. Du kan alltid avslå.",
      trust3: "Garantert parkeringsplass",
      trust3Body: "Når du har forhåndsbestilt, er plassen din — ingen overraskelser.",
      trust4: "Lokal lansering",
      trust4Body: "Vi starter i Asker. Vi lanserer nye områder fortløpende.",
      faqTitle: "Spørsmål vi hører ofte",
      faqs: [
        { q: "Når lanserer Pendli?", a: "Vi lanserer først i Asker. Registrer deg så får tilgang til Pendli app'en når den går live. Vi bygger sakte og lokalt — én stasjon om gangen." },
        { q: "Hvordan funker betaling?", a: "Pendlere betaler når de forhåndsbestiller en parkeringsplass. Pendli håndterer hele betalingen og utbetaler inntektene til huseieren. Pendli tar en mindre tjenestavgift for å drifte plattformen. Endelig prisstruktur vil bli bekreftet før lansering." },
        { q: "Hva koster det?", a: "Pendli tar en mindre tjenestavgift for å drifte plattformen. Endelig prisstruktur — inkludert tidlige fordeler for de første huseierne — bekreftes før lansering." },
        { q: "Er Pendli en app?", a: "Ja, men appen lanseres når vi har nok plasser på en stasjon. Akkurat nå samler vi listen som starter alt." },
      ],
      bannerTitle: "Asker stasjon. Først ut.",
      bannerBody: "Vi starter med ett nabolag: Asker, Høn, Vakås, Hvalstad og Billingstad. Bor eller pendler du nær en av disse stasjonene — registrer deg nå og få tilgang til Pendli først.",
    },
    huseier: {
      heroEyebrow: "Pilot — Asker, Høn, Vakås, Hvalstad og Billingstad",
      stations: ["Asker", "Høn", "Vakås", "Hvalstad", "Billingstad"],
      stationsLead: "Bor du nær en av disse stasjonene? Registrer deg for tidlig tilgang.",
      heroTitle: "Står oppkjørselen din tom?",
      heroTitleAccent: "La den tjene deg penger.",
      heroSub: "Gjør din ubrukte parkeringsplass om til 1 000–2 500 kr i måneden.",
      heroLead: "Ved å dele plassen din på dagtid kan du tjene ekstra penger og samtidig hjelpe en nabo med pendlingshverdagen.",
      heroBullets: [
        { title: "Full kontroll", body: "Du bestemmer selv når plassen er ledig." },
        { title: "Null styr", body: "Vi håndterer alt det praktiske og utbetaler direkte til din konto." },
        { title: "100 % uforpliktende", body: "Gratis å registrere." },
      ],
      heroCta: "Få tidlig tilgang",
      calcTitle: "Regn ut hva oppkjørselen din kan tjene",
      calcDailyLabel: "Dagspris du setter",
      calcDaysLabel: "Hverdager utleid per måned",
      calcResultLabel: "Din potensielle inntekt",
      calcMonthly: "kr/mnd",
      calcNote: "Pendli håndterer hele betalingen og tar en mindre tjenestavgift for å drifte plattformen. Endelig prisstruktur — inkludert fordeler for de første 100–200 huseierne — bekreftes før lansering.",
      valuesTitle: "Hvorfor liste oppkjørselen din?",
      values: [
        { title: "Du styrer alt selv", body: "Du setter dagsraten og eier kalenderen. Blokker plassen de dagene du trenger den selv — ferie? Skru av." },
        { title: "Pendli håndterer hele betalingen", body: "Pendlere betaler når de forhåndsbestiller. Pendli utbetaler inntektene til deg — ingen fakturering, ingen oppfølging." },
        { title: "Gratis å liste", body: "Du registrerer gratis. Pendli tar bare en andel når du faktisk tjener." },
        { title: "Verifiserte pendlere", body: "Alle som forhåndsbestiller er verifisert. Du ser navn og kontakt — og kan alltid avslå." },
        { title: "Founder-prioritet", body: "De første 100–200 huseierne får våre beste vilkår når vi lanserer. Endelig prisstruktur bekreftes før lansering." },
        { title: "Inntekten kan være skattefri", body: "Avhengig av din situasjon kan inntekten fra å leie ut parkeringsplassen din være skattefri. For de fleste privatpersoner er den det." },
      ],
      founderBadge: "FOUNDER-PRIORITET",
      founderBadgeBody: "Beste vilkår når vi lanserer — låst for de første 100–200 huseierne. Endelig prisstruktur bekreftes før lansering. Vi teller fra dagen du registrerer deg.",
      formEyebrow: "Tidlig tilgang",
      formTitle: "Ja, jeg vil ha tidlig tilgang",
      formSub: "Bor du nær Asker, Høn, Vakås, Hvalstad eller Billingstad stasjon? Skriv inn navn og kontakt, så blir du blant de første huseierne som får tidlig tilgang til appen.",
      faqTitle: "Vanlige spørsmål fra huseiere",
      faqs: [
        { q: "Hvilke stasjoner er med i den første piloten?", a: "Bor du nær en av følgende stasjoner kan du registrere deg for tidlig tilgang til å leie ut parkeringsplassen eller oppkjørselen din: Asker, Høn, Vakås, Hvalstad og Billingstad." },
        { q: "Hva hvis noen skader noe?", a: "Pendli jobber med å bygge inn forsikringsdekning på plattformen. Vi kan ikke love detaljer ennå, men du registrerer deg uten forpliktelse og hører mer når vi lanserer." },
        { q: "Hva hvis sameiet/borettslaget ikke tillater det?", a: "Helt forståelig. Registrer deg uansett — vi sender deg en informasjonspakke du kan vise til styret, og du bestemmer selv om du går videre." },
        { q: "Kan jeg blokkere plassen når jeg vil?", a: "Ja. Du eier kalenderen 100%. Skal du ha besøk eller bruke plassen selv? Slå av med ett trykk." },
        { q: "Hvem parkerer der?", a: "Bare pendlere som er verifisert i appen. Du ser navn og kontaktinfo — og du kan alltid avslå en forhåndsbestilling før den starter." },
        { q: "Når får jeg pengene?", a: "Pendli håndterer hele betalingen ved forhåndsbestilling og utbetaler inntektene til deg. Endelige rutiner for utbetaling og betalingsmåte bekreftes før lansering." },
      ],
    },
    pendler: {
      heroEyebrow: "Pilot — Asker, Høn, Vakås, Hvalstad og Billingstad",
      stations: ["Asker", "Høn", "Vakås", "Hvalstad", "Billingstad"],
      stationsLead: "Pendler du fra en av disse stasjonene? Registrer deg for tidlig tilgang.",
      heroTitle: "Plassen din er ledig",
      heroTitleAccent: "og venter på deg.",
      heroSub: "Forhåndsbook en privat plass nær stasjonen du pendler fra — Asker, Høn, Vakås, Hvalstad eller Billingstad. Den er låst inn på ditt navn. Du kjører rett dit. Ingen sirkling. Ingen usikkerhet.",
      heroCta: "Få tidlig tilgang",
      comparisonTitle: "Stasjonens anlegg vs. Pendli",
      comparisonStation: "Anlegget ved stasjonen",
      comparisonPendli: "Pendli",
      comparisons: [
        { station: "Fullt fra 07:30", pendli: "Garantert ledig — alltid" },
        { station: "Sirkling og stress", pendli: "Plassen står og venter" },
        { station: "Vet aldri om du får plass", pendli: "Låst på navnet ditt før du drar" },
        { station: "Anonymt parkeringsselskap", pendli: "Pengene går til en nabo" },
        { station: "Automat, app, bot", pendli: "Pendli håndterer alt" },
      ],
      valuesTitle: "Hvorfor pendlere bytter til Pendli",
      values: [
        { title: "Plassen står og venter", body: "Når du kommer, står plassen din der. Ikke 'kanskje', ikke 'sannsynligvis' — låst på navnet ditt." },
        { title: "Aldri mer sirkling", body: "Du kjører rett til plassen din. Som å eie den, bare uten å eie den." },
        { title: "Praktisk beliggenhet", body: "Plasser nær stasjonen og kollektivtransport. Eksakt gangavstand vises for hver enkelt plass i appen." },
        { title: "Forutsigbar pris", body: "En fast pris satt av naboen. Ingen overraskelser, ingen automater som krever tre apper." },
        { title: "Enkel betaling", body: "Du betaler når du forhåndsbestiller. Pendli håndterer resten — ingen automater, ingen kort, ingen apper med tre passord." },
        { title: "Månedsabonnement", body: "Tegn et månedsabonnement og lås samme plass — hver dag, hver uke." },
      ],
      formEyebrow: "Tidlig tilgang",
      formTitle: "Sikre deg tidlig tilgang til Pendli",
      formSub: "Pendler du fra Asker, Høn, Vakås, Hvalstad eller Billingstad? Skriv inn navn, kontakt og hvilken stasjon du pendler fra, så blir du blant de første som får tilgang til appen.",
      faqTitle: "Vanlige spørsmål fra pendlere",
      faqs: [
        { q: "Hva koster en plass?", a: "Huseier setter prisen, men de fleste ligger godt under halvparten av stasjonens anlegg. Tegn månedsabonnement for ekstra rabatt." },
        { q: "Hva hvis huseieren ombestemmer seg?", a: "En forhåndsbestilling er en forhåndsbestilling. Pendli garanterer plassen. Hvis noe skjer på huseiers side, finner vi en alternativ plass eller refunderer fullt ut." },
        { q: "Hvilke stasjoner dekker dere?", a: "I den første piloten kan du finne parkering nær Asker, Høn, Vakås, Hvalstad og Billingstad stasjon. Deretter utvider vi til flere stasjoner i Oslo-området, så Bergen, Stavanger og videre i Norden. Registrer deg så får du beskjed når vi kommer til din stasjon." },
        { q: "Må jeg laste ned en app?", a: "Når vi lanserer — ja. Akkurat nå holder det å bli med på listen. Du får appen først." },
        { q: "Kan jeg parkere over natten?", a: "Det avhenger av huseier. Mange tillater overnatting, andre kun arbeidstid. Du ser dette på hver plass før du forhåndsbestiller." },
      ],
    },
    kontakt: {
      heroEyebrow: "Kontakt",
      heroTitle: "Si hei.",
      heroSub: "Spørsmål, samarbeid, eller bare nysgjerrig på Pendli? Send oss en melding. Vi svarer som regel innen 24 timer.",
      formTitle: "Send oss en melding",
      info: "Vi bygger Pendli i Asker, for Norden. Først ut: Asker stasjon.",
      emailLabel: "E-post",
      pressLabel: "Presse & samarbeid",
      successOverride: "Takk for meldingen — vi tar kontakt snart.",
    },
    seo: {
      home: {
        title: "Pendli – parkering nær stasjonen",
        description: "Lei en ledig parkeringsplass – eller tjen penger på din egen. Lanseres i Asker.",
      },
      pendler: {
        title: "Parkering for pendlere — Pendli",
        description: "Forhåndsbook en privat parkeringsplass nær stasjonen. Garantert ledig, kort gangavstand. Få tidlig tilgang når Pendli åpner i Asker.",
      },
      huseier: {
        title: "Tjen penger på oppkjørselen din — Pendli",
        description: "Gjør din ubrukte parkeringsplass om til 1 000–2 500 kr i måneden. Du styrer alt selv, og avhengig av din situasjon kan inntekten være skattefri. Gratis å registrere.",
      },
      om: {
        title: "Om Pendli — laget i Asker",
        description: "Pendli utvikles av Simon og Erik, to lokale gründere i Asker. Vi bygger en enkel og trygg tjeneste som kobler pendlere med private parkeringsplasser.",
      },
      kontakt: {
        title: "Kontakt Pendli",
        description: "Spørsmål, samarbeid eller innspill? Ta kontakt med Pendli. Vi svarer som regel innen 24 timer.",
      },
      personvern: {
        title: "Personvernerklæring — Pendli",
        description: "Slik samler, bruker og beskytter Pendli personopplysningene dine.",
      },
      vilkar: {
        title: "Vilkår for bruk — Pendli",
        description: "Vilkårene for bruk av Pendli sine nettsider og tjenester.",
      },
    },
    footer: {
      tagline: "Parkering, løst. For naboer som hjelper naboer.",
      sections: { product: "Produkt", company: "Selskap", legal: "Juridisk" },
      links: {
        pendler: "For pendlere",
        huseier: "For huseiere",
        om: "Om oss",
        kontakt: "Kontakt",
        about: "Om Pendli",
        privacy: "Personvern",
        terms: "Vilkår",
      },
      rights: "Alle rettigheter reservert.",
      built: "Bygges i Asker. Lanseres i Asker.",
    },
  },
  en: {
    nav: {
      home: "Home",
      huseier: "Hosts",
      pendler: "Commuters",
      om: "About us",
      kontakt: "Contact",
      cta: "Get notified",
      langToggle: "NO",
    },
    common: {
      submit: "Notify me when Pendli launches",
      submitting: "Sending...",
      successTitle: "You're on the list.",
      successBody: "We'll email you the moment Pendli launches in your area.",
      privacy: "We don't share your information. You can unsubscribe any time.",
      consentLabel: "I have read and accept the",
      consentLinkText: "privacy policy",
      consentRequired: "You must accept the privacy policy to continue.",
      namePlaceholder: "Your name",
      contactPlaceholder: "Email or phone",
      messagePlaceholder: "Message (optional)",
      stationPlaceholder: "Station you commute from",
      addressPlaceholder: "Address (street, area)",
      errorGeneric: "Something went wrong. Please try again.",
      forCommuters: "For commuters",
      forHomeowners: "For hosts",
      learnMore: "Learn more",
    },
    home: {
      heroEyebrow: "Launching soon — Asker station",
      heroTitle: "Guaranteed parking near your station.",
      heroTitleAccent: "Your spot is waiting.",
      heroSub: "Pre-book a private spot with a neighbour near the station you commute from. It's there when you arrive. No circling, no uncertainty, and no lot that's full by 07:30.",
      ctaPendler: "I'm a commuter",
      ctaHuseier: "I have a driveway",
      problemEyebrow: "The problem",
      problemTitle: "Every morning, it's the same.",
      problemBody: "You drive to the station. The lot is full. You circle. You pay over 100 NOK to stay all day — or get fined. Meanwhile, thousands of driveways sit empty just meters away.",
      howEyebrow: "How it works",
      howTitle: "Three steps. No circling.",
      step1Title: "Find your spot",
      step1Body: "Search your station. See private spots within short walking distance of the station.",
      step2Title: "Pre-book",
      step2Body: "Pick a day or get a monthly pass. Your spot is guaranteed.",
      step3Title: "Park. Walk to the train. Done.",
      step3Body: "Park and walk to the train. Pendli handles the entire payment and pays out earnings to the neighbour.",
      audienceTitle: "Two sides of the same driveway.",
      audiencePendlerTitle: "You commute",
      audiencePendlerBody: "Stop circling. Your spot is locked in before you leave the house — and waiting for you when you arrive.",
      audienceHuseierTitle: "You have an empty driveway",
      audienceHuseierBody: "It sits empty while you're at work. Earn 1,000–2,500 NOK/month. You set the price.",
      trustTitle: "Built for Nordic neighbours.",
      trust1: "Pendli handles the entire payment",
      trust1Body: "Commuters pay when they pre-book. Pendli pays out the earnings to the host.",
      trust2: "Verified users",
      trust2Body: "You see who pre-books. You can always decline.",
      trust3: "Guaranteed parking spot",
      trust3Body: "Once you've pre-booked, the spot is yours — no surprises.",
      trust4: "Local launch",
      trust4Body: "We start in Asker. We're rolling out new areas continuously.",
      faqTitle: "Questions we hear a lot",
      faqs: [
        { q: "When does Pendli launch?", a: "We launch in Asker first. Sign up and we'll notify you the moment we go live. We build slowly and locally — one station at a time." },
        { q: "How do payments work?", a: "Commuters pay when they book a parking spot. Pendli handles the payment and pays out earnings to the host. Pendli takes a small service fee to run the platform. Final pricing will be confirmed before launch." },
        { q: "What does it cost?", a: "Pendli takes a small service fee to run the platform. Final pricing — including early benefits for the first hosts — will be confirmed before launch." },
        { q: "Is Pendli an app?", a: "Yes, but the app launches once we have enough spots at a station. Right now we're building the list that starts it all." },
      ],
      bannerTitle: "Asker station. First out.",
      bannerBody: "We start with one neighbourhood: Asker, Høn, Vakås, Hvalstad and Billingstad. Live or commute near one of these stations — sign up now and get access to Pendli first.",
    },
    huseier: {
      heroEyebrow: "Pilot — Asker, Høn, Vakås, Hvalstad and Billingstad",
      stations: ["Asker", "Høn", "Vakås", "Hvalstad", "Billingstad"],
      stationsLead: "Live near one of these stations? Sign up for early access.",
      heroTitle: "Is your driveway empty?",
      heroTitleAccent: "Let it earn you money.",
      heroSub: "Turn your unused parking spot into 1,000–2,500 NOK per month.",
      heroLead: "By sharing your spot during the day you can earn extra income and help a neighbour with their commute at the same time.",
      heroBullets: [
        { title: "Full control", body: "You decide when the spot is available." },
        { title: "Zero hassle", body: "We handle all the practical stuff and pay out directly to your account." },
        { title: "100% no obligation", body: "Free to register." },
      ],
      heroCta: "Get early access",
      calcTitle: "See what your driveway could earn",
      calcDailyLabel: "Daily price you set",
      calcDaysLabel: "Weekdays rented per month",
      calcResultLabel: "Your potential earnings",
      calcMonthly: "NOK/mo",
      calcNote: "Pendli handles the entire payment and takes a small service fee to run the platform. Final pricing — including benefits for the first 100–200 hosts — will be confirmed before launch.",
      valuesTitle: "Why list your driveway?",
      values: [
        { title: "You're in full control", body: "You set the daily rate and own the calendar. Block the spot on days you need it — holiday? Switch off." },
        { title: "Pendli handles the entire payment", body: "Commuters pay when they pre-book. Pendli pays out the earnings to you — no invoicing, no follow-up." },
        { title: "Free to list", body: "Listing is free. Pendli only takes a cut when you actually earn." },
        { title: "Verified commuters", body: "Every booker is verified. You see name and contact — and can decline." },
        { title: "Founder priority", body: "The first 100–200 hosts get our best terms when we launch. Final pricing will be confirmed before launch." },
        { title: "Your income can be tax-free", body: "Depending on your situation, the income from renting out your parking spot can be tax-free. For most private individuals, it is." },
      ],
      founderBadge: "FOUNDER PRIORITY",
      founderBadgeBody: "Best terms when we launch — locked for the first 100–200 hosts. Final pricing will be confirmed before launch. We count from the day you register.",
      formEyebrow: "Early access",
      formTitle: "Yes, I want early access",
      formSub: "Live near Asker, Høn, Vakås, Hvalstad or Billingstad station? Enter your name and contact, and you'll be among the first hosts to get early access to the app.",
      faqTitle: "Common host questions",
      faqs: [
        { q: "Which stations are part of the first pilot?", a: "If you live close to one of the following stations, you can sign up for early access to rent out your parking spot or driveway: Asker, Høn, Vakås, Hvalstad and Billingstad." },
        { q: "What if someone damages something?", a: "Pendli is building insurance coverage into the platform. We can't promise details yet, but you register with no obligation and hear more when we launch." },
        { q: "What if my building doesn't allow it?", a: "Totally fair. Sign up anyway — we'll send you an info pack you can show the board, and you decide whether to go ahead." },
        { q: "Can I block the spot whenever?", a: "Yes. You own the calendar 100%. Visitors coming? Need it yourself? Toggle off in one tap." },
        { q: "Who's parking there?", a: "Only commuters verified in the app. You see name and contact — and you can always decline a booking before it starts." },
        { q: "When do I get paid?", a: "Pendli handles the entire payment at pre-booking and pays out the earnings to you. Final payout routines and payment method will be confirmed before launch." },
      ],
    },
    pendler: {
      heroEyebrow: "Pilot — Asker, Høn, Vakås, Hvalstad and Billingstad",
      stations: ["Asker", "Høn", "Vakås", "Hvalstad", "Billingstad"],
      stationsLead: "Commute from one of these stations? Sign up for early access.",
      heroTitle: "Your spot is free",
      heroTitleAccent: "and waiting for you.",
      heroSub: "Pre-book a private spot near the station you commute from — Asker, Høn, Vakås, Hvalstad or Billingstad. It's locked in under your name. You drive straight to it. No circling. No uncertainty.",
      heroCta: "Get early access",
      comparisonTitle: "Station lot vs. Pendli",
      comparisonStation: "The station's lot",
      comparisonPendli: "Pendli",
      comparisons: [
        { station: "Full by 07:30", pendli: "Guaranteed available — always" },
        { station: "Circling and stress", pendli: "Your spot is waiting" },
        { station: "Never know if you'll get a space", pendli: "Locked under your name before you leave" },
        { station: "Anonymous parking company", pendli: "Money goes to a neighbour" },
        { station: "Meter, app, fine", pendli: "Pendli handles it all" },
      ],
      valuesTitle: "Why commuters switch to Pendli",
      values: [
        { title: "Your spot is waiting", body: "When you arrive, your spot is there. Not 'maybe', not 'probably' — locked under your name." },
        { title: "Never circle again", body: "Drive straight to your spot. Like owning it, without owning it." },
        { title: "Convenient location", body: "Spots near the station and public transit. Exact walking distance is shown for each spot in the app." },
        { title: "Predictable price", body: "A fixed price set by the neighbour. No surprises, no meter that needs three apps." },
        { title: "Simple payment", body: "You pay when you book. Pendli handles the rest — no meters, no cards, no apps with three passwords." },
        { title: "Monthly pass", body: "Get a monthly pass and lock in the same spot — every day, every week." },
      ],
      formEyebrow: "Early access",
      formTitle: "Secure your early access to Pendli",
      formSub: "Commute from Asker, Høn, Vakås, Hvalstad or Billingstad? Enter your name, contact and which station you commute from, and you'll be among the first to get access to the app.",
      faqTitle: "Common commuter questions",
      faqs: [
        { q: "How much does a spot cost?", a: "The host sets the price, but most sit well below half of the station's lot. Get a monthly pass for an extra discount." },
        { q: "What if the host changes their mind?", a: "A booking is a booking. Pendli guarantees the spot. If something happens on the host's end, we find you an alternative or refund in full." },
        { q: "Which stations do you cover?", a: "In the first pilot you can find parking near Asker, Høn, Vakås, Hvalstad and Billingstad station. After that we expand to more stations in the Oslo area, then Bergen, Stavanger and across the Nordics. Sign up and we'll tell you when we reach your station." },
        { q: "Do I need an app?", a: "When we launch — yes. Right now, signing up to the list is enough. You'll get the app first." },
        { q: "Can I park overnight?", a: "Depends on the host. Many allow overnight, others only working hours. You'll see this on each spot before you book." },
      ],
    },
    kontakt: {
      heroEyebrow: "Contact",
      heroTitle: "Say hi.",
      heroSub: "Questions, partnerships, or just curious about Pendli? Drop us a message. We usually reply within 24 hours.",
      formTitle: "Send us a message",
      info: "We build Pendli in Asker, for the Nordics. First out: Asker station.",
      emailLabel: "Email",
      pressLabel: "Press & partnerships",
      successOverride: "Thanks — we'll be in touch soon.",
    },
    seo: {
      home: {
        title: "Pendli – parking near the station",
        description: "Rent a free parking spot – or earn money from your own. Launching in Asker.",
      },
      pendler: {
        title: "Parking for commuters — Pendli",
        description: "Pre-book a private parking spot near the station. Guaranteed available, short walk. Get early access when Pendli opens in Asker.",
      },
      huseier: {
        title: "Earn money from your driveway — Pendli",
        description: "Turn your unused parking spot into 1,000–2,500 NOK per month. You're in full control, and depending on your situation the income can be tax-free. Free to register.",
      },
      om: {
        title: "About Pendli — built in Asker",
        description: "Pendli is built by Simon and Erik, two local founders in Asker. We're building a simple, trustworthy service connecting commuters with private parking spots.",
      },
      kontakt: {
        title: "Contact Pendli",
        description: "Questions, partnerships or feedback? Get in touch with Pendli. We usually reply within 24 hours.",
      },
      personvern: {
        title: "Privacy Policy — Pendli",
        description: "How Pendli collects, uses and protects your personal data.",
      },
      vilkar: {
        title: "Terms of Use — Pendli",
        description: "The terms for using Pendli's websites and services.",
      },
    },
    footer: {
      tagline: "Parking, solved. For neighbours who help neighbours.",
      sections: { product: "Product", company: "Company", legal: "Legal" },
      links: {
        pendler: "For commuters",
        huseier: "For hosts",
        om: "About us",
        kontakt: "Contact",
        about: "About Pendli",
        privacy: "Privacy",
        terms: "Terms",
      },
      rights: "All rights reserved.",
      built: "Built in Asker. Launching in Asker.",
    },
  },
};
